import React from 'react';
import { Zap, Linkedin, Twitter, Github, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative bg-black border-t border-white/10">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <Zap className="w-6 h-6 text-[#FF6600] fill-[#FF6600]" />
              <div>
                <h3 className="text-xl font-bold text-white">Intellapoint</h3>
                <p className="text-[10px] text-gray-400 -mt-1">AI Intelligence to the point</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Empowering businesses with AI agents that drive growth and secure local LLM processing.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-white/5 hover:bg-[#FF6600]/20 border border-white/10 hover:border-[#FF6600]/30 flex items-center justify-center transition-all duration-300"
              >
                <Linkedin className="w-5 h-5 text-gray-400 hover:text-[#FF6600]" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-white/5 hover:bg-[#FF6600]/20 border border-white/10 hover:border-[#FF6600]/30 flex items-center justify-center transition-all duration-300"
              >
                <Twitter className="w-5 h-5 text-gray-400 hover:text-[#FF6600]" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-white/5 hover:bg-[#FF6600]/20 border border-white/10 hover:border-[#FF6600]/30 flex items-center justify-center transition-all duration-300"
              >
                <Github className="w-5 h-5 text-gray-400 hover:text-[#FF6600]" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-white/5 hover:bg-[#FF6600]/20 border border-white/10 hover:border-[#FF6600]/30 flex items-center justify-center transition-all duration-300"
              >
                <Mail className="w-5 h-5 text-gray-400 hover:text-[#FF6600]" />
              </a>
            </div>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-white font-semibold mb-4">Product</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('agents')}
                  className="text-gray-400 hover:text-[#FF6600] transition-colors duration-200 text-sm"
                >
                  AI Agents
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('security')}
                  className="text-gray-400 hover:text-[#FF6600] transition-colors duration-200 text-sm"
                >
                  Security
                </button>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#FF6600] transition-colors duration-200 text-sm">
                  OpenClaw Platform
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#FF6600] transition-colors duration-200 text-sm">
                  Integrations
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#FF6600] transition-colors duration-200 text-sm">
                  Pricing
                </a>
              </li>
            </ul>
          </div>

          {/* Solutions */}
          <div>
            <h4 className="text-white font-semibold mb-4">Solutions</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('usecases')}
                  className="text-gray-400 hover:text-[#FF6600] transition-colors duration-200 text-sm"
                >
                  Use Cases
                </button>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#FF6600] transition-colors duration-200 text-sm">
                  Sales Teams
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#FF6600] transition-colors duration-200 text-sm">
                  Enterprise
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#FF6600] transition-colors duration-200 text-sm">
                  Startups
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#FF6600] transition-colors duration-200 text-sm">
                  Agencies
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-[#FF6600] transition-colors duration-200 text-sm">
                  About Us
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#FF6600] transition-colors duration-200 text-sm">
                  Careers
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#FF6600] transition-colors duration-200 text-sm">
                  Blog
                </a>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-[#FF6600] transition-colors duration-200 text-sm"
                >
                  Contact
                </button>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#FF6600] transition-colors duration-200 text-sm">
                  Support
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} Intellapoint. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-gray-400 hover:text-[#FF6600] transition-colors duration-200 text-sm">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-[#FF6600] transition-colors duration-200 text-sm">
                Terms of Service
              </a>
              <a href="#" className="text-gray-400 hover:text-[#FF6600] transition-colors duration-200 text-sm">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
